/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */
import React, { ReactNode } from 'react'

import AssetTableCell from './AssetTableCell'
import { isNullOrUndefined } from './utils'

type DefaultColProps = {
  value: string | number | null
}

const DefaultCol: React.FC<DefaultColProps> = ({ value }) => {
  const displayBlank = isNullOrUndefined(value) || value === ''

  let displayValue: ReactNode = <div className="h-4 w-full flex"></div>
  if (!displayBlank) {
    displayValue = value
  }

  return <AssetTableCell>{displayValue}</AssetTableCell>
}

export default DefaultCol
